// extracted by mini-css-extract-plugin
module.exports = {"article-actions":"blog-article_article-actions__23AQ_","article-actions-link":"blog-article_article-actions-link__225MA"};